import { render } from "./TestWord.vue?vue&type=template&id=4ab5b49c&scoped=true"
const script = {}

import "./TestWord.vue?vue&type=style&index=0&id=4ab5b49c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab5b49c"]])

export default __exports__